export const Data = [
    {
        from: 2022,
        title: "The Web Developer bootcamp",
        school: "Udemy - Colt Steele",
        details: `My first fullstack development course. I bought the course since 2021 but did not finally finish it till 2023. You can verify \n`,
        url: `http://ude.my/UC-ae070ffc-8e29-4436-b853-409ad816eeb1`
    },
    {
        from: 2023,
        title: "Meta Front-End Developer",
        school: "Meta - coursera",
        details: `I extensively learnt frontend development from meta. You can verify \n`,
        url: `https://coursera.org/share/b57f29315197da67f1e737a7d56aaf8d`
    },
    {
        from: 2023,
        title: "Meta Back-end Developer",
        school: "Meta - coursera",
        details: `I learnt backend development from meta, coupled with my existing knowledge from udemy. You can verify \n`,
        url: `https://coursera.org/share/377030981f865b27049370ba6344ba5cv`
    },
    {
        from: 2023,
        title: "Medical Physiology",
        school: "Ekiti State University",
        details: `Studied medical physiology as health and fitness is also an interest of mine`,
    }
  
]